<template>
  <v-container class="app">
    <v-row no-gutters>
      <v-col
        v-for="location in locations"
        :key="location.code"
        cols="12"
        sm="4"
      >
        <Crumb
          :isNext="isNext(location)"
          :location="location"
          :btnText="visitedTs(location)"
          v-on="handler"
        ></Crumb>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src

import support from "../plugins/support";
import Crumb from "../components/Crumb.vue";
export default {
  name: "Survey-Breadcrumb-Form",
  components: { Crumb },
  data() {
    return {
      handler: {
        dropCrumb: this.dropCrumb,
      },
      required: [(v) => !!v || "Required"],
      record: {},
      tableName: "survey_breadcrumb",
      last_checked: 0,
    };
  },
  created () {
    console.log(support.data.REFBREADCRUMB);
    console.log(support.data.SURVEYBREADCRUMB);
  },
  mounted() {},
  methods: {
    dropCrumb(record) {
      record.ts = support.getLocalTimestamp(new Date());
      this.$emit("dropCrumb", record);
    },
    isNext(location) {
      return location.sequence == this.last_checked + 1;
    },
    visitedTs(location) {
      let survey = support.provideRecord(support.data.SURVEYEFFORT);

      let crumbs = this.$store.getters['shared/dataTables'][support.data.SURVEYBREADCRUMB];
      console.log(crumbs);
      let visit_ts = this.$store.getters['shared/dataTables'][support.data.SURVEYBREADCRUMB]
        .filter(function (el) {
          return (
            el["survey_ts"] == survey.survey_ts &&
            el["survey_tablet"] == survey.survey_tablet &&
            el["breadcrumb_location_code"] == location.code
          );
        })
        .map((item) => item.ts);
      if (visit_ts.length < 1) {
        return "now";
      } else {
        return visit_ts[visit_ts.length - 1].substring(11, 16);
      }
      //this.btntext = new Date().toISOString().substr(11, 5);
    },
  },

  computed: {
    refTables() {
      return this.$store.getters['shared/refTables']
    },
    locations() {
     
      if (this.refTables[support.data.REFBREADCRUMB].length > 1) {
        return this.refTables[support.data.REFBREADCRUMB];
      } else {
        return [];
      }
    },
  },
};
</script>
